import React, { forwardRef } from 'react';

import { styled } from '@mui/material';

import palette from '../theme/palette';

export const Input = styled('input')({
  width: '100%',
  height: '14px',
  background: 'transparent',
  border: 'none',
  outline: 'none',
  fontSize: '12px',
  fontWeight: 400,
  '::placeholder': {
    color: palette.grey[600],
    fontWeight: 500,
    fontSize: '13px'
  }
});

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  type: string;
  placeholder: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

const TextInput = forwardRef<HTMLInputElement | null, TextInputProps>(
  ({ type, placeholder, value, onChange, ...props }, ref) => (
    <Input
      ref={ref}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      {...props}
    />
  )
);

TextInput.displayName = 'TextInput';

export default TextInput;
